import type { ReactElement } from 'react'
import { cn } from 'app/lib/utils'
import { shortDate } from 'app/components/action-center/treatmentDisplay'
import type { TreatmentCard } from 'app/types/treatment'
import { formatCurrency } from 'lib/formatCurrency'
import { TREATMENT_LIST } from 'lib/systemLists'

/** The patient and when the plan was made, opposite the money that put the card in its stage. */
export function CaseHeaderSection({ card }: { card: TreatmentCard }): ReactElement {
  const presented = shortDate(card.presented)
  // A booking is what moved the card to Scheduled, so there the headline is what is on the calendar.
  const scheduled = card.treatmentStatus === TREATMENT_LIST.bookedStage
  return (
    <div className="flex items-start justify-between gap-2">
      <div className="min-w-0">
        <p className="truncate text-ui-sm text-strong">{card.name}</p>
        <p className="mt-0.5 text-body-xs leading-tight text-minimal">
          {presented ? `Presented ${presented}` : `No presented date`}
        </p>
      </div>
      <div className="shrink-0 text-right">
        {/* oxlint-disable-next-line shadcn/no-raw-colors -- moved verbatim under the G7 parity net */}
        <p className={cn(`gilroy text-lg leading-none`, scheduled ? `text-strong` : `text-amber-700`)}>
          {formatCurrency(scheduled ? card.scheduledValue : card.value)}
        </p>
        <p className="mt-0.5 text-body-xs leading-tight text-minimal">{scheduled ? `scheduled` : `unscheduled`}</p>
      </div>
    </div>
  )
}
